import { useEffect, useState } from 'react';

export const useTextAreaNumberOfLines = (textAreaElement, dependencies = []) => {
  const [numberOfLines, setNumberOfLines] = useState(1);

  useEffect(() => {
    if (!textAreaElement) return undefined;

    // forced reflow: required because textAreaElement.scrollHeight isn't getting updated correctly upon pressing backspace and enter
    // Deferred to rAF so the layout read happens off the keystroke -> paint path,
    // and cancelling any pending frame means fast typing coalesces into one
    // reflow per paint instead of stacking one per keystroke.
    const frame = requestAnimationFrame(() => {
      const styles = getComputedStyle(textAreaElement);
      const lineHeight = parseFloat(styles.lineHeight);
      const lines = Math.floor(textAreaElement.scrollHeight / lineHeight);
      setNumberOfLines(lines);
    });

    return () => cancelAnimationFrame(frame);
  }, dependencies);

  return numberOfLines;
};
